export enum DeviceStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    ERROR = 'ERROR',
    PAUSED = 'PAUSED'
}

export type Device = {
    id: number
    type: string
    status: DeviceStatus
}

export type DeviceUpdate = {
    id: number
    device_type: string
    status: DeviceStatus
    ip_address: string
    port: number
    _gateway_id: number
}